import { create } from 'zustand'

type ModalType =
	| 'deposit-primary'
	| 'manual-transfer'
	| 'moonpay-deposit'
	| 'lifi-deposit'
	| 'hyperliquid-deposit'
	| 'withdraw'
	| 'transfer-prompt'
	| 'command-palette'
	| 'coming-soon'
	| 'auth'
	| 'bridge'
	| 'support'
	| 'pnl-calendar'
	| 'kyc-verification'
	| 'copy-trading-setup'
	| 'tip'
	| 'join-chance-ai'

type TransferPromptData = {
	requiredAmount: number
	targetPlatform: 'polymarket' | 'kalshi'
	onSuccess?: () => void
}

type CopyTradingData = {
	traderId: string
	traderName: string
	traderWallet: string
	editRelationshipId?: string
	// Current settings for edit mode
	currentSettings?: {
		scalingMethod: string
		scalingValue: number
		maxPerTrade: number | null
		minTradeSize: number | null
		maxTotalExposure: number | null
		retryEnabled: boolean
		filters: { filterType: string; filterValue: string }[]
	}
}

type ModalState = {
	activeModal: ModalType | null
	transferPromptData: TransferPromptData | null
	copyTradingData: CopyTradingData | null
	openModal: (modal: ModalType) => void
	openTransferPrompt: (data: TransferPromptData) => void
	openCopyTradingSetup: (data: CopyTradingData) => void
	closeModal: () => void
}

export const useModalStore = create<ModalState>(set => ({
	activeModal: null,
	transferPromptData: null,
	copyTradingData: null,
	openModal: modal => set({ activeModal: modal, transferPromptData: null, copyTradingData: null }),
	openTransferPrompt: data =>
		set({ activeModal: 'transfer-prompt', transferPromptData: data, copyTradingData: null }),
	openCopyTradingSetup: data =>
		set({ activeModal: 'copy-trading-setup', transferPromptData: null, copyTradingData: data }),
	closeModal: () => set({ activeModal: null, transferPromptData: null, copyTradingData: null }),
}))
